import moment from 'moment-wrapper';

export default function calculatePeriodFromRangeKey (rangeKey, calculateFutureDays) {
  let period = {};

  switch (rangeKey) {
  case 'Yesterday':
    period.startDate = moment().subtract(1, 'days');
    period.endDate = moment().subtract(1, 'days');
    break;
  case 'Last 7 days':
    period.startDate = moment().subtract(7, 'days');
    period.endDate = moment().subtract(1, 'days');
    break;
  case 'This week':
    period.startDate = moment().startOf('week');
    if (calculateFutureDays) {
      period.endDate = moment().endOf('week');
    } else {
      period.endDate = moment();
    }
    break;
  case 'Last week':
    period.startDate = moment().subtract(1, 'week').
      startOf('week');
    period.endDate = moment().subtract(1, 'week').
      endOf('week');
    break;
  case 'This month':
    period.startDate = moment().startOf('month');
    if (calculateFutureDays) {
      period.endDate = moment().endOf('month');
    } else {
      period.endDate = moment();
    }
    break;
  case 'Last month':
    period.startDate = moment().subtract(1, 'month').
      startOf('month');
    period.endDate = moment().subtract(1, 'month').
      endOf('month');
    break;
  default:
    break;
  }

  period.startDate = period.startDate.format('YYYY-MM-DD');
  period.endDate = period.endDate.format('YYYY-MM-DD');

  return period;
}
